/**
 * @ param aptValidity
 *    external function to be executed in local scope
 *    **NOTE: the only requirement for the external function is that
 *    it needs to return a truthy if the value is "valid" - otherwise it will be
 *    marked "invalid" making the model's state invalid.
 *    **FYI - it is native functionally for the model value to only be broadcasted when
 *    validity state changes or when value changes when model is valid
 *
 * @ param aptValidityClass (optional) - default: ng-valid/invalid-apt-validatity
 *    override for the validity state class for this namespace.
 *    Will be be applied to the element to indicate the validity state e.g. ng-valid-apt-validity
 *    ng-valid and ng-invalid are always applied automatically as prefix and as separate classes
 *
 * USAGE:  <element apt-validity='myScopeFn' apt-validity-class  />
 *
 *
 * TODO: add option to push as $formatter so this validator is run as soon as element is rendered
 * - for now only pushing as $parser so this validator is only run after the value has changed
 *
 * FIXME: doesn't seem to be working with nested models e.g(map.model)
 */
export default function AptValidity() {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      validationFn: '&aptValidity',
      validationClass: '@aptValidityClass'
    },
    link: function ($scope, $element, $attrs, $modelController) {
      var validationClass = $scope.validationClass || 'aptValidity';

      // custom validator to be executed as part of the normal validation process
      var validator = function (viewValue) {
        var isValid;
        var parameterMap = {};
        var modelName = $attrs.ngModel;

        // create object map and use model name as key to provide value to external function
        parameterMap[modelName] = viewValue;

        // NOTE: don't forget to return true if the model is valid
        isValid = $scope.validationFn(parameterMap) ? true : false;

        // set valid state for model and provide validity state class
        $modelController.$setValidity(validationClass, isValid);

        // as an ngModelController requirement
        // returning undefined when invalid basically tells the modelController to
        // not update the modelValue
        return isValid ? viewValue : undefined;
      };

      $modelController.$parsers.push(validator);
    }
  };
}
